import React from "react";
import { useNavigate } from "react-router-dom";
import "./Explore.css";
import image3 from "../../Images/skill1.png";
import image4 from "../../Images/skill3.png";
import foodarna1 from "../../Images/foodarna1.png";
import foodarna2 from "../../Images/foodarna2.png";
import shopifyStripeBg from "../../Images/shopifystripebg.png";
import shopifystripeFront from "../../Images/shopifystripefront.png";
import testitudeFront from "../../Images/testitudeFront.png";
import testitudeBack from "../../Images/testitudeBack.png";

const WorkCard = ({ mainImage, smallImage, title, subtitle, tags, onClick, isMobile }) => {
  return (
    <div className="explore-list-contet" onClick={onClick}>
      <div className="image-content">
        <img src={mainImage} alt={title} style={{ width: "100%", margin: "auto" }} />
        <img src={smallImage} alt={title} className="small-img" />
      </div>
      {isMobile ? (
        <div>
          <div>
            <h3 className="text-header-work">{title}</h3>
            {subtitle && <p className="text-title-work">{subtitle}</p>}
          </div>
          <div className="tag-content-list">
            {tags.map((tag, index) => (
              <p key={index} className="tag-content">
                {tag}
              </p>
            ))}
          </div>
        </div>
      ) : (
        <div>
          <div className="test-flex-project">
            <h3>{title}</h3>
            {subtitle && <p>{subtitle}</p>}
          </div>
          <div className="test-flex-project">
            <div className="tag-content-list">
              {tags.map((tag, index) => (
                <span key={index} className="tag-content">
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const ExploreWork = () => {
  const navigate = useNavigate();
  const isMobile = window.innerWidth < 768;

  const workData = [
    {
      mainImage: testitudeBack,
      smallImage: testitudeFront,
      title: "Testitude",
      subtitle: "Test Management Tool",
      tags: ["API Testing", "JIRA Integrated", "Quality Analysis"],
      onClick: () => navigate("/testitude"),
    },
    {
      mainImage: image3,
      smallImage: image4,
      title: "Skillioz",
      subtitle: "Application Tracking System",
      tags: ["CV Comparison Using AI", "Hiring Candidates", "Job Postings"],
      onClick: () => navigate("/prodetail"),
    },
    {
      mainImage: foodarna2,
      smallImage: foodarna1,
      title: "Mobile App Development",
      subtitle: "From Idea to App Store - We Build What Moves You!",
      tags: ["Optimized Performance", "Responsive", "Simple Interfaces"],
      onClick: () => navigate("/foodrana"),
    },
    {
      mainImage: shopifyStripeBg,
      smallImage: shopifystripeFront,
      title: "Next-Level Tools for Shopify,Stripe & monday.com Users ",
      subtitle: "",
      tags: [
        "Seamless Integration",
        "Product review Management",
        "Live Invoice Editing",
        "Real-Time Updates",
        " Customizable Exports",
      ],
      onClick: () => navigate("/shopify-stripe"),
    },
  ];

  return (
    <div style={{ width: "100%" }}>
      <h1
        style={{
          fontSize: "26px",
          width: "85%",
          margin: "auto",
          textAlign: isMobile ? "center" : "left",
        }}
        className="!pt-[2rem] md:!pt-[3rem] text-white"
      >
        Explore Our Works
      </h1>
      <div className="explore-work-content">
        {workData.map((work, index) => (
          <WorkCard key={index} {...work} isMobile={isMobile} />
        ))}
      </div>
    </div>
  );
};

export default ExploreWork;
